<tt-page>
    <tt-page-heading></tt-page-heading>
    <tt-doc-pack-type [params]="params" (submit)="onSubmit($event)"></tt-doc-pack-type>
</tt-page>
